import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./keyfobdetails.module.css";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";
import { ArrowLeft, Home, X } from "react-feather";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import KeyfobDetailsCard from "./components/details/KeyfobDetailsCard";
import KeyfobTabs from "./components/details/KeyfobTabs";
import Footer from "../../../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import { TableLoader } from "../../../components/LoaderC";
import AddLock from "./components/details/AddLock";

const KeyfobDetails = ({ history, match }) => {
    const { id } = match.params;
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [deviceDetails, setDeviceDetails] = useState(null);
    const [lockList, setLockList] = useState([]);
    const [addLockPopup, setAddLockPopup] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteCardId, setDeleteCardId] = useState(0);
    const [mdeleteModalOpen, setmDeleteModalOpen] = useState(false);
    const [mdeleteCardId, setmDeleteCardId] = useState([]);
    const [deleteModalOpen2, setDeleteModalOpen2] = useState(false);

    useEffect(() => {
        const getCardDetails = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios.get(process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs/' + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setContentLoading(false);
                let dData = response.data.data;
                if (dData.length > 0) {
                    setDeviceDetails({ 'id': dData[0]?.id, 'card_name': dData[0]?.card_name, 'card_number': dData[0]?.card_number, 'card_type': dData[0]?.card_type });
                    let lockListT = dData?.map(i => {
                        return { id: i?.id, device_id: i?.device_id, lock_id: i?.lock_id, lock_name: i?.lock_name_new, created_at: i?.created_at };
                    });

                    setLockList(lockListT);
                }
            }).catch(error => {
                setContentLoading(false);
            });
        }

        if (id) {
            getCardDetails();
        }
    }, [id, getAccessTokenSilently]);

    const addLock = (data) => {
        let newData = data?.map(i => {
            return { id: i?.id, device_id: i?.device_id, lock_id: i?.lock_id, lock_name: i?.lock_name_new };
        });

        setLockList(prev => {
            return prev.concat(newData);
        });
    }

    const confirmDelete = async () => {
        setLoading(true);
        setDeleteModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.delete(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/keyfob-lock/" + deleteCardId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            if (lockList.length === 1) {
                setTimeout(() => {
                    redirect.push('/smart-devices/keyfobs');
                }, 2000);
            } else {
                setLockList(prev => {
                    return prev.filter(i => i?.id !== deleteCardId);
                });
            }

            setDeleteCardId(0);

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const confirmmDelete = async () => {
        if (mdeleteCardId.length === 0) {
            toast.error('Please select device.');
            return false;
        }

        let postData = { keyfobs: mdeleteCardId };
        setLoading(true);
        setmDeleteModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs/" + deviceDetails?.id + "/delete-lock", postData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setAddLockPopup(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            if (lockList.length === mdeleteCardId.length) {
                setTimeout(() => {
                    redirect.push('/smart-devices/keyfobs');
                }, 2000);
            } else {
                setLockList(prev => {
                    return prev.filter(i => mdeleteCardId.indexOf(i?.id) === -1);
                });
            }

            setmDeleteCardId([]);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });

    }

    const confirmDelete2 = async () => {
        setDeleteModalOpen2(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs/' + deviceDetails?.card_number, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setTimeout(() => {
                redirect.push('/smart-devices/keyfobs');
            }, 2000);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return <>
        {loading && <Loader />}

        <Helmet title={deviceDetails?.card_name} />

        <div className={`${styles.mainCard}`}>
            {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

            {!contentLoading && <div className={`${styles.SMProCusRow}`}>

                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Smart Devices</li>
                            <li className={`${styles.breadcrumbItem}`}>Manage Keyfob</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>{deviceDetails?.card_name}</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link onClick={() => redirect.goBack()} className={`${styles.BackArrow}`}>
                                <ArrowLeft />
                            </Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>{deviceDetails?.card_name}</Typography>
                        </div>
                    </div>
                </div>

                <KeyfobDetailsCard deviceDetails={deviceDetails} setDeleteModalOpen2={setDeleteModalOpen2.bind(this)} />

                <KeyfobTabs lockList={lockList} setAddLockPopup={setAddLockPopup.bind(this)} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardId={setDeleteCardId.bind(this)} setmDeleteModalOpen={setmDeleteModalOpen.bind(this)} setmDeleteCardId={setmDeleteCardId.bind(this)} mdeleteCardId={mdeleteCardId} />

            </div>}
        </div>

        <Dialog
            open={addLockPopup}
            onClose={(e) => setAddLockPopup(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setAddLockPopup(false)}><ArrowLeft /></button>
                Add Lock
                <button onClick={(e) => setAddLockPopup(false)}><X /></button>
            </DialogTitle>
            <DialogContent className={`${styles.RequestBodyPop}`}>
                <AddLock setAddLockPopup={setAddLockPopup.bind(this)} setLoading={setLoading.bind(this)} addlockList={lockList} deviceDetails={deviceDetails} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} onSubmitLocal={addLock.bind(this)} />
            </DialogContent>
        </Dialog>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this lock?
                <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The keyfob information will be removed from lock immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={mdeleteModalOpen}
            onClose={(e) => setmDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete selected locks?
                <button onClick={(e) => setmDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The keyfob information will be removed from selected locks immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setmDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={deleteModalOpen2}
            onClose={(e) => setDeleteModalOpen2(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this keyfob?
                <button onClick={(e) => setDeleteModalOpen2(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The keyfob information will be removed immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete2()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen2(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>
}

export default withAuthenticationRequired(KeyfobDetails, {
    onRedirecting: () => <Loader />,
});